// Fired by the narrator when a dialog node flagged `openMerchant` is entered.
// The merchant UI listens for this to open its sell/buy panel.
export enum MerchantEventBus {
  open = 'merchantOpen',
}
